import { makeStyles } from "@mui/styles"

export default makeStyles(() => ({
  root: {
    width: '100%',
    backgroundColor: '#ffffff',
    padding: '2rem',
    border: '1px solid #ddd',
    borderTop: 'none',
    borderRadius: '0 0 5px 5px',
    maxHeight: '550px',
    overflow: "hidden",
    boxShadow:
      '0px 2px 4px -1px #00000033, 0px 4px 5px 0px #00000024, 0px 1px 10px 0px #0000001F',
    position: 'relative',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
  },

  '@keyframes skeleton-loading': {
    from: {
      backgroundColor: '#CCC',
    },
    to: {
      backgroundColor: '#DDD',
    },
  },

  skeleton: {
    backgroundColor: '#CCC',
    animation: '$skeleton-loading 500ms linear infinite alternate',
  },

  skeletonText: {
    width: '100%',
    height: '5rem',
    borderRadius: '12px',
  },

  skeletonTextBody: {
    width: '100%',
  },

  skeletonFooter: {
    width: '30%',
  },
}))
